"use client";

import { usePortfolioBuilderStore } from "@/stores/portfolioBuilderStore";
import { useTenant } from "@/hooks/useTenant";

const EXPERIENCE_LABELS = ["Beginner", "Basic", "Intermediate", "Advanced", "Expert"];

const FIELDS = [
  {
    key: "experienceStocks" as const,
    label: "Stocks & ETFs",
    desc: "Equity markets, index funds",
  },
  { key: "experienceOptions" as const, label: "Options", desc: "Calls, puts, spreads" },
  {
    key: "experienceFutures" as const,
    label: "Futures",
    desc: "ES, NQ, commodity futures",
  },
  { key: "experienceCrypto" as const, label: "Crypto", desc: "Spot, perpetuals, DeFi" },
];

export function ExperienceStep() {
  const store = usePortfolioBuilderStore();
  const { marketScope } = useTenant();

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold">Trading Experience</h2>
        <p className="mt-1 text-sm text-gray-400">
          Rate your experience level in each asset class (1-5).
        </p>
      </div>

      {marketScope === "futures" && (
        <p className="rounded-md border border-blue-800/50 bg-blue-900/20 p-3 text-sm text-blue-400">
          This builder is configured for regulated futures and futures options.
        </p>
      )}

      <div className="space-y-5">
        {FIELDS.map(({ key, label, desc }) => (
          <div key={key} className="rounded-lg border border-gray-800 bg-gray-900/50 p-4">
            <div className="mb-3 flex items-center justify-between">
              <div>
                <span className="font-medium">{label}</span>
                <span className="ml-2 text-xs text-gray-500">{desc}</span>
              </div>
              <span className="text-sm font-medium text-blue-400">
                {EXPERIENCE_LABELS[store[key] - 1]}
              </span>
            </div>
            <input
              type="range"
              min={1}
              max={5}
              step={1}
              value={store[key]}
              onChange={(e) => store.setExperience(key, Number(e.target.value))}
              className="w-full accent-blue-500"
            />
            <div className="mt-1 flex justify-between text-xs text-gray-600">
              {EXPERIENCE_LABELS.map((l) => (
                <span key={l}>{l}</span>
              ))}
            </div>
          </div>
        ))}
      </div>

      {store.experienceFutures < 2 && (
        <p className="rounded-md border border-amber-800/50 bg-amber-900/20 p-3 text-sm text-amber-400">
          Minimum Basic futures experience is required to receive a portfolio
          recommendation.
        </p>
      )}

      <div className="flex justify-end">
        <button
          onClick={() => store.nextStep()}
          className="rounded-lg bg-blue-600 px-6 py-2.5 text-sm font-medium hover:bg-blue-500 transition-colors"
        >
          Next
        </button>
      </div>
    </div>
  );
}
